// /////////// wishlist cookie
function getCookie(name) {
    const nameEQ = `${name  }=`;
    const ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
  
        let c = ca[i];
        while (c.charAt(0)===' ') c = c.substring(1,c.length);
  
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        ;
    }
   
    return null;
  }
  
  
  // /////////// wishlist cookie

function wishListUpdate(){
  const cookie = getCookie('NF_WISH_LIST');

  const wishlists = document.querySelectorAll('.wishlist');
  


  if (wishlists){
    
    const wishlistsBtn = document.querySelector('.wishlistButton');
    const wishlistCounter =  document.querySelector('.wishlistCounter');

    // const cookieArr = cookie ? cookie.split('/') : '';
    if (cookie){
      let  cookieArr = cookie.split('/');

      [].forEach.call(wishlists, function(wishlist) {
        wishlist.classList.remove('active');
        
        if (cookieArr.includes(wishlist.getAttribute('data-wishid'))){
          wishlist.classList.add('active');
        }
        if (wishlistsBtn){
          if (wishlistCounter){
            wishlistCounter.innerHTML = cookieArr.length;
            wishlistCounter.classList.add('active');
          }
          wishlistsBtn.classList.remove('disabled');
        }
      });
      // console.log(cookieArr.length);
    }else{
      // console.log('test');
      [].forEach.call(wishlists, function(wishlist) {
        wishlist.classList.remove('active');
        // wishlistCounter.classList.add('active');
      });
      if (wishlistsBtn){
        wishlistsBtn.classList.add('disabled');
        if (wishlistCounter){
          wishlistCounter.innerHTML = "";
          wishlistCounter.classList.remove('active');
        }
      }
    }
    // const cookieArr = cookie.split('/');
    

    // const wishlistsBtn = document.querySelector('.wishlistButton');
    // wishlistsBtn.dataset.wishlistcount = cookieArr.length;
    
  }
}

wishListUpdate();

function addRemoveCookie(...theArgs){

  const csrf = document.querySelector('meta[name="csrf-token"]').content;  
  const xhrurl = 'assets/components/nonfiction/webconnector.php';

  const params = {
    action: 'addremovecookie',
    addRemoveCookie: `name=${theArgs[0]}&action=${theArgs[1]}&value=${theArgs[2]}` ,
  };
  const data = new URLSearchParams(params).toString();

  // console.log (data);
  const xhr = new XMLHttpRequest();
  xhr.open("POST", xhrurl, true);
  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.setRequestHeader('X-CSRF-TOKEN', csrf); 
  xhr.send(data);
  xhr.onload = function() {
    wishListUpdate();
    // console.log(xhr.response);
  }

}


document.addEventListener('click', function(e) {

    if (e.target.classList.contains('wishlist')){
        e.preventDefault();

        if (e.target.classList.contains('active')){
          // e.target.classList.remove('active');
          addRemoveCookie('NF_WISH_LIST', 'remove',e.target.getAttribute('data-wishid'))
          
        }else{
          // e.target.classList.add('active');
          addRemoveCookie('NF_WISH_LIST', 'add',e.target.getAttribute('data-wishid'))
          
        }
        return ;
    };
});


module.exports = wishListUpdate;